import { initializeVectorTileMap } from "../../components/mapViews/vectorTile/Map";
import { initializeGoogleMap } from '../../components/mapViews/googleMap/Map';
/**
 * @category Get started
 * @deprecated loadVectorTileMap function is deprecated use vectorTileMap instead
 * @example
 * ```typescript
 * let config = {
                proxyURL: '',  // proxy URL
                urlPrefix: [],  // array of string for unreal urls
                baseMapURL: '',   // the basemap url
                title: '', // title for basemap
                id: '',  // id for basemap
                divContainer: 'view',  // id for dom elemnt for map in html
                attributionControl: false,
                zoomControl: 'top-left',
                minScale: 18489334.715908278,  // set minScale for map to avoid hide map on browser
                zoomlevel: 8,  // zoom level for map on initialization
                thumbnailUrl: '' // url for your image for this map
            }
            let mapView = momraGisCore.vectorTileMap(config);
 * ```
*/
export function vectorTileMap(mapOptions) {
    mapOptions = {
        baseMapURL: mapOptions.baseMapURL,
        title: mapOptions.title,
        id: mapOptions.id,
        divContainer: mapOptions.divContainer,
        attributionControl: mapOptions.attributionControl,
        proxyURL: mapOptions.proxyURL,
        urlPrefix: mapOptions.urlPrefix,
        urlsInterceptors: mapOptions.urlsInterceptors,
        zoomControl: mapOptions.zoomControl,
        thumbnailUrl: mapOptions.thumbnailUrl,
        minScale: mapOptions.minScale,
        zoomlevel: mapOptions.zoomlevel,
        injectSecurityCode: mapOptions.injectSecurityCode
    };
    return initializeVectorTileMap(mapOptions);
}
/**
 * @category Get started
 * @version 1.0.4 or higher
 * @example
 * ```typescript
 * let config = {
                proxyURL: '',  // proxy URL
                urlPrefix: [],  // array of string for unreal urls
                baseMapURL: 'http://mt{subDomain}.google.com/vt/lyrs=m&hl=en&gl=en&x={col}&y={row}&z={level}&s=png&hl=ar-EG&apistyle=s.t%3A17%7Cs.e%3Al.t%7Cp.v%3Aoff%2Cs.t%3A6%7Cs.e%3Al%7Cp.v%3Aoff',   // the basemap url example for googlemap
                title: '', // title for basemap
                id: '',  // id for basemap
                divContainer: 'view',  // id for dom elemnt for map in html
                attributionControl: false,
                zoomControl: 'top-left',
                minScale: 18489334.715908278,  // set minScale for map to avoid hide map on browser
                zoomlevel: 8,  // zoom level for map on initialization
                thumbnailUrl: '' // url for your image for this map
            }
            let mapView = momraGisCore.googlebaseMap(config);
 * ```
*/
export function googlebaseMap(mapOptions) {
    mapOptions = {
        baseMapURL: mapOptions.baseMapURL,
        title: mapOptions.title,
        id: mapOptions.id,
        divContainer: mapOptions.divContainer,
        attributionControl: mapOptions.attributionControl,
        proxyURL: mapOptions.proxyURL,
        urlPrefix: mapOptions.urlPrefix,
        urlsInterceptors: mapOptions.urlsInterceptors,
        zoomControl: mapOptions.zoomControl,
        thumbnailUrl: mapOptions.thumbnailUrl,
        minScale: mapOptions.minScale,
        zoomlevel: mapOptions.zoomlevel,
        injectSecurityCode: mapOptions.injectSecurityCode
    };
    return initializeGoogleMap(mapOptions);
}
